import React from 'react';
import {hubspotContactValueOptions} from '../../../hubspotContactValue';
import {HubspotContactCheckboxSearchCondition} from './types';

interface Props {
  property?: {
    options?: {label?: string | null; value?: string | null}[] | null;
  };
  value: HubspotContactCheckboxSearchCondition['value'];
  onChange: (value: HubspotContactCheckboxSearchCondition['value']) => void;
}

const CheckboxValue = ({property, value, onChange}: Props) => (
  <select
    className="form-select border-c-border rounded text-base w-40 h-[44px]"
    value={value ?? ''}
    onChange={(e) =>
      onChange(e.target.value as HubspotContactCheckboxSearchCondition['value'])
    }
  >
    <option value="" />
    {hubspotContactValueOptions(property).map((option) => (
      <option value={option.value} key={option.value}>
        {option.label}
      </option>
    ))}
  </select>
);

export default CheckboxValue;
